import { paragraphSplitter } from 'shared-code/string'
import { DSAlign, DSButtonIcon, DSNCLinkedButtons, DSNCString } from 'shared-definitions/types'
import { htmlMapper } from 'data-source/mappers/htmlMapper'

export function ncString(input: string): ExtractedComponent[] {
  let result: ExtractedComponent[] = []

  const regex = /(<a[^>]*aa_button[^>]*>)([^<]*)<\/a>/gs
  let match
  let cursor = 0

  while ((match = regex.exec(input))) {
    result = result.concat(componentStringMapper(input.slice(cursor, match.index)))
    cursor = match.index + match[0].length

    const extracted = extractLinkedButton(match)
    if (extracted) {
      if (result.length) {
        const last = result[result.length - 1]
        if (last.resource === 'nc-linked-buttons') {
          last.buttons = last.buttons.concat(extracted.buttons)
          continue
        }
      }

      result.push(extracted)
    }
  }

  result = result.concat(componentStringMapper(input.slice(cursor)))

  return result
}

function componentStringMapper(input: string): DSNCString[] {
  const parts = paragraphSplitter(htmlMapper(input))
  return parts
    .filter(html => !/^(?:\s*|&\w+;|\\n)*$/gs.test(html))
    .map(html => ({
      resource: 'nc-string',
      html,
    }))
}

type ExtractedComponent = DSNCString | DSNCLinkedButtons

function extractLinkedButton([_, attrs, body]: string[]): DSNCLinkedButtons | null {
  const link = /href="([^"]*)"/gs.exec(attrs)
  if (!link) {
    return null
  }

  const rel = /rel="([^"]*)"/gs.exec(attrs)
  const align = /fasc-alignment-(\w+)/.exec(attrs)
  const icon = /cbs-([\w-]+)/.exec(attrs)
  const target = /target="([^"]*)"/gs.exec(attrs)

  return {
    resource: 'nc-linked-buttons',
    buttons: [
      {
        label: body,
        pLink: {
          href: link[1],
          rel: rel ? rel[1] : 'nofollow noreferrer',
          ...(target ? { target: target[1] } : {}),
        },
        align: align ? (align[1] as DSAlign) : null,
        icon: icon ? (icon[1] as DSButtonIcon) : null,
        color: null,
      },
    ],
  }
}
